import { Paper } from "@mui/material";

const Sidebar = props => {
    return <>
        <Paper
            sx={{
                position: { xs: 'static', sm: 'sticky' },
                top: '84px',
                flexGrow: 1,
                p: { xs: 1, sm: 3 },
                width: { xs: '100dvw', sm: '250px' },
                maxWidth: { xs: '100dvw', sm: '250px' },
                minWidth: { xs: '100dvw', sm: '250px' },
                boxSizing: { xs: 'border-box', sm: 'initial' }
            }}
            elevation={3}>
            {props.content}
        </Paper>
    </>;
};

export default Sidebar;
